import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { RichTextInput } from 'ra-input-rich-text';
import {
  BooleanInput,
  Create,
  FormTab,
  getRecordFromLocation,
  NumberInput,
  SelectInput,
  TabbedForm,
  TextInput,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

// TODO: generalize components

export const CreditCardProductCreate: React.FC = () => {
  const location = useLocation();
  const record = getRecordFromLocation(location);
  return (
    <Create>
      <TabbedForm>
        <FormTab label="Základné info">
          <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
          <InstitutionInput source="institutionId" />
          <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
          <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Zmluva">
          <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
          <DateInput label="Dátum podpisu zmluvy" source="contractSignDate" />
          <DateInput label="Platnosť zmluvy do" source="contractEndDate" />
        </FormTab>

        <FormTab label="Platby">
          <ExpectedAmountInput label="Výška splátky" source="paymentPeriod.expectedAmount.amount" />
          <TextInput source="paymentPeriod.expectedAmount.currency" style={{ display: 'none' }} value="EUR" />
          <NumberInput label="Opakovať každých" source="paymentPeriod.periodCount" />
          <SelectInput choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
          <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
        </FormTab>

        <FormTab label="Údaje pre platbu">
          <TextInput
            label="Variabilný symbol"
            source="paymentInfo.variableSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Špecifický symbol"
            source="paymentInfo.specificSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Konštantný symbol"
            source="paymentInfo.constantSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput label="IBAN" source="paymentInfo.ibanForPayment" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Informácie o kreditnej karte">
          <DateInput defaultValue={new Date()} label="platné k" source="financialDetailsUpdatedAt" />
          <NumberInput label="Limit úverového rámca" source="limitAmount.amount" />
          <BooleanInput label="Využívaná na pravidelné nákupy" source="regularUsage" />
          <BooleanInput label="Úverový rámec vyrovnaný do splatnosti" source="owedAmountPaidByMaturity" />
        </FormTab>

        <FormTab label="Status">
          <ProductStatusInput label="Status" source="status" />
        </FormTab>

        <FormTab label="Poznámka">
          <RichTextInput
            label="Poznámka"
            source="note"
            sx={{ '& .tiptap': { minHeight: '20em' }, maxWidth: '40em', width: '100%' }}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
